import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthHttp } from 'src/app/views/login/commons/http/auth.http';
import { UserHttp } from 'src/app/views/login/commons/http/user.http';
import { SessionHandlerService } from 'src/app/views/login/commons/services/session-handler.service';
import { BaseComponent } from './base/base.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { ToastComponent } from './toast/toast.component';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';

const COMPONENTS = [
    BaseComponent,
    FooterComponent,
    UserAvatarComponent,
    HeaderComponent,
    ToastComponent
];

@NgModule({
    declarations: [ ...COMPONENTS ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        NgbToastModule,
        HttpClientModule
    ],
    providers: [ UserHttp, SessionHandlerService, AuthHttp ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    exports: [ ...COMPONENTS ]
})
export class ComponentsModule { }
